export const DEFAULT_AVATAR = { skin: "#C68642", hair: "curly", hair_color: "#2B1B10", eyes: "happy", shirt: "#6B9080", accessory: "none", bg: "#F2D49B" };

const HAIR = {
  short: (c) => <path d="M28 44 Q28 22 50 21 Q72 22 72 44 Q66 32 50 31 Q34 32 28 44Z" fill={c} />,
  curly: (c) => <g fill={c}>{[30, 38, 46, 54, 62, 70].map((x, i) => <circle key={x} cx={x} cy={i % 2 ? 27 : 30} r="8" />)}<circle cx="27" cy="40" r="6" /><circle cx="73" cy="40" r="6" /></g>,
  long: (c) => <path d="M26 46 Q24 20 50 19 Q76 20 74 46 L76 78 L66 78 L66 42 Q50 32 34 42 L34 78 L24 78Z" fill={c} />,
  puffs: (c) => <g fill={c}><circle cx="26" cy="26" r="11" /><circle cx="74" cy="26" r="11" /><path d="M30 40 Q32 24 50 24 Q68 24 70 40 Q60 32 50 32 Q40 32 30 40Z" /></g>,
  braids: (c) => <g fill={c}><path d="M28 44 Q28 22 50 21 Q72 22 72 44 Q66 32 50 31 Q34 32 28 44Z" /><rect x="22" y="42" width="7" height="34" rx="3.5" /><rect x="71" y="42" width="7" height="34" rx="3.5" /></g>,
  spiky: (c) => <path d="M28 42 L30 24 L37 32 L42 18 L48 30 L54 17 L59 30 L65 20 L68 32 L72 26 L72 42 Q50 30 28 42Z" fill={c} />,
  bun: (c) => <g fill={c}><circle cx="50" cy="16" r="9" /><path d="M28 44 Q28 22 50 21 Q72 22 72 44 Q66 32 50 31 Q34 32 28 44Z" /></g>,
  none: () => null,
};
const EYES = {
  round: <g fill="#2C2C2C"><circle cx="42" cy="48" r="3.2" /><circle cx="58" cy="48" r="3.2" /></g>,
  happy: <g stroke="#2C2C2C" strokeWidth="2.6" fill="none" strokeLinecap="round"><path d="M38 49 Q42 45 46 49" /><path d="M54 49 Q58 45 62 49" /></g>,
  wink: <g stroke="#2C2C2C" strokeWidth="2.6" fill="#2C2C2C" strokeLinecap="round"><circle cx="42" cy="48" r="3" stroke="none" /><path d="M54 49 L62 49" fill="none" /></g>,
  sparkle: <g><circle cx="42" cy="48" r="4" fill="#2C2C2C" /><circle cx="58" cy="48" r="4" fill="#2C2C2C" /><circle cx="43.4" cy="46.6" r="1.3" fill="#fff" /><circle cx="59.4" cy="46.6" r="1.3" fill="#fff" /></g>,
};
const ACC = {
  none: null,
  glasses: <g stroke="#2C2C2C" strokeWidth="2" fill="none"><circle cx="42" cy="48" r="7" /><circle cx="58" cy="48" r="7" /><path d="M49 48 L51 48" /></g>,
  headband: <rect x="28" y="30" width="44" height="6" rx="3" fill="#E05A47" />,
  cap: <g fill="#3B6EA8"><path d="M27 38 Q28 18 50 18 Q72 18 73 38Z" /><rect x="50" y="34" width="30" height="5" rx="2.5" /></g>,
  bow: <g fill="#D9608B"><path d="M60 24 L70 18 L70 32Z" /><path d="M60 24 L50 18 L50 32Z" /><circle cx="60" cy="25" r="3" /></g>,
  headphones: <g fill="none" stroke="#2C4A3E" strokeWidth="4"><path d="M26 50 Q26 20 50 20 Q74 20 74 50" /><rect x="21" y="44" width="9" height="14" rx="4" fill="#2C4A3E" /><rect x="70" y="44" width="9" height="14" rx="4" fill="#2C4A3E" /></g>,
};

export const KidAvatar = ({ a, className = "w-16 h-16", testId }) => {
  const v = { ...DEFAULT_AVATAR, ...(a || {}) };
  return (
    <svg viewBox="0 0 100 100" className={`${className} shrink-0`} data-testid={testId} role="img" aria-label="avatar">
      <circle cx="50" cy="50" r="50" fill={v.bg} />
      <path d="M18 100 Q20 74 50 72 Q80 74 82 100Z" fill={v.shirt} />
      <rect x="44" y="62" width="12" height="12" rx="4" fill={v.skin} />
      {v.hair === "long" && HAIR.long(v.hair_color)}
      <circle cx="50" cy="47" r="22" fill={v.skin} />
      {v.hair !== "long" && HAIR[v.hair]?.(v.hair_color)}
      {EYES[v.eyes]}
      <circle cx="37" cy="56" r="3.5" fill="#E8A0A0" opacity="0.5" /><circle cx="63" cy="56" r="3.5" fill="#E8A0A0" opacity="0.5" />
      <path d="M43 58 Q50 64 57 58" stroke="#7A3B2E" strokeWidth="2.4" fill="none" strokeLinecap="round" />
      {ACC[v.accessory]}
    </svg>
  );
};

export const OPTIONS = {
  skin: ["#FBE3CF", "#F1C27D", "#E0AC69", "#C68642", "#8D5524", "#5C3A1E"],
  hair: Object.keys(HAIR),
  hair_color: ["#2B1B10", "#5B3A1E", "#A0522D", "#D9A441", "#E07A2E", "#6B4FA0", "#3B82C4"],
  eyes: Object.keys(EYES),
  shirt: ["#6B9080", "#C87D53", "#3B6EA8", "#D9608B", "#F2C14E", "#7B5EA7", "#2C4A3E"],
  accessory: Object.keys(ACC),
  bg: ["#F2D49B", "#C8DCCB", "#BFD4E6", "#F6C6A8", "#D9D4E7", "#F1EADB"],
};
